import React, { useState, useEffect } from 'react';
import { accountService, alertService } from '../_services';
import jwt_decode from "jwt-decode";
import { Loading } from '../_components';

import '../styles.css';
import '../queries.css';

function GoogleLoginButton() {

    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false);

    const google = window.google;

    function handleCallbackResponse(response) {
        setLoading(true);
        //console.log("TOKEN" + response.credential);
        var userObject = jwt_decode(response.credential);
        console.log(userObject);
        console.log(userObject.email);


        accountService.googleLogin(response.credential)
            .then(() => {
                window.location.href = "/";
            })
            .catch(error => {
                alertService.error(error);
                setLoading(false);
            });
    }

    function showButton(user) {

        //this line is needed for Kahil's tests to pass- can't figure out why. 
        if ((google != undefined) && (user == null || (Object.keys(user).length == 0))) {
            //if ( (user == null || (Object.keys(user).length == 0))) {
            google.accounts.id.initialize({
                client_id: accountService.configValue['google_client_id'],
                callback: handleCallbackResponse
            });

            google.accounts.id.renderButton(
                document.getElementById("google_sign_in"),
                { these: "outline", size: "large" }
            );
        }
    }

    useEffect(() => {
        const subscription = accountService.user.subscribe(x => { setUser(x); showButton(x) });
        return () => {
            subscription.unsubscribe();
        }
    }, []);

    return (<div>
        <div id="google_sign_in" hidden={loading}></div>
        {loading && <Loading />}
    </div>
    );


}

export { GoogleLoginButton };